'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const reactAriaComponents = require('react-aria-components');

const listBoxSection = "_list-box-section_kecdg_1";
const label = "_label_kecdg_14";
const styles = {
	listBoxSection: listBoxSection,
	label: label
};

const TypeaheadSection = (_a) => {
  var { children, id, size = "large", label } = _a, props = tslib_es6.__rest(_a, ["children", "id", "size", "label"]);
  return jsxRuntime.jsxs(reactAriaComponents.ListBoxSection, Object.assign({ className: styles.listBoxSection, "data-size": size, "data-zds-typeahead-section": true, id }, props, { children: [jsxRuntime.jsx(reactAriaComponents.Header, { className: styles.label, children: label }), children] }));
};

exports.TypeaheadSection = TypeaheadSection;
//# sourceMappingURL=TypeaheadSection.cjs.js.map
